<template>
    <v-card>
        <v-toolbar color="primary lighten-1" dark flat>
            <v-toolbar-title>Benachrichtigungen</v-toolbar-title>
            <v-spacer/>
            <v-btn text :to="{name: 'CreateCampaign'}">
                <v-icon>mdi-plus</v-icon>
                erstellen
            </v-btn>
        </v-toolbar>

        <v-simple-table>
            <thead>
            <tr>
                <th>Typ</th>
                <th>Benachrichtigung</th>
                <th>App</th>
                <th>Kanal</th>
            </tr>

            </thead>
            <tbody v-if="campaigns.length > 0">
            <tr v-for="campaign in campaigns" :key="campaign.id"
                :class="{scheduledCampaign: campaign.type==='queued_job'}"
                @click="$router.push({name: 'ShowCampaign', params: {id: campaign.id, type: campaign.type}})">
                <td>
                    {{ scheduleLabel(campaign) }}
                    <v-icon>{{ getNotificationIcon(campaign) }}</v-icon>
                </td>
                <td>
                    <p class="text-subtitle-1 mt-1">{{ getNotificationTitle(campaign) }}</p>
                    <div class="mb-1"
                         style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis; width: 800px">
                        {{ getNotificationContent(campaign) }}
                    </div>
                </td>
                <td>
                    <v-chip v-for="app in campaign.apps"
                            class="my-1 mx-1"
                            label
                            small>
                        {{ getAppById(app.id).name }}
                    </v-chip>
                </td>
                <td>
                    <v-chip v-show="campaign.channel_api"
                            label
                            small
                            class="my-1">
                        <v-icon>mdi-cellphone-text</v-icon>
                        In App
                    </v-chip>
                    <v-chip v-show="campaign.channel_apn"
                            label
                            small
                            class="my-1">
                        <v-icon>mdi-apple</v-icon>
                        Push iOS
                    </v-chip>
                    <v-chip v-show="campaign.channel_android"
                            label
                            small
                            class="my-1">
                        <v-icon>mdi-android</v-icon>
                        Push Android
                    </v-chip>
                </td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr>
                <td>Für die ausgewähle Sprache existieren noch keine Einträge.</td>
            </tr>
            </tbody>
        </v-simple-table>
        <v-pagination v-model="page" :length="pageCount" :total-visible="7"/>
    </v-card>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import notificationTypes from "../../utils/notificationTypes";
import moment from "moment";

export default {
    name: "CampaignList",
    props: {
        filters: {
            type: Object,
            default: () => ({
                apps: [],
                language: 'de',
                types: [],
            })
        }
    },
    mounted() {
        if (!this.campaignsLoaded) {
            this.loadCampaigns();
        }
    },
    data() {
        return {
            page: 1,
            itemsPerPage: 9,
            language: 'de',
        };
    },
    computed: {
        ...mapState('campaign', [
            'isLoading',
        ]),
        ...mapGetters('campaign', [
            'campaignsLoaded',
            'getCampaignsForLanguage',
            'getNotification',
            'filterCampaigns'
        ]),
        ...mapGetters('app', [
            'getAppById'
        ]),
        pageCount() {
            return Math.ceil(this.filteredCampaigns.length / this.itemsPerPage);
        },
        filteredCampaigns() {
            return this.filterCampaigns(
                this.filters.language,
                this.filters.apps,
                this.filters.types
            );
        },
        campaigns() {
            return this.paginate(this.filteredCampaigns);
        },
        scheduleLabel: () => (campaign) => {
            return campaign.type === 'queued_job'
                ? 'Geplant für ' + moment(campaign.schedule).format('DD.MM.YYYY HH:mm')
                : '';

        }
    },
    methods: {
        ...mapActions('campaign', [
            'loadCampaigns',
        ]),
        paginate(campaigns) {
            let start = (this.page - 1) * this.itemsPerPage;
            return campaigns.slice(start, start + this.itemsPerPage);
        },
        getNotificationIcon(campaign) {
            let type = this.getNotification(campaign, this.filters.language).type;
            return notificationTypes[type];
        },
        getNotificationTitle(campaign) {
            return this.getNotification(campaign, this.filters.language).title;
        },
        getNotificationContent(campaign) {
            return this.getNotification(campaign, this.filters.language).content;
        },
        campaignHasApp(campaign, app) {
            return campaign.apps.find(listedApp => listedApp.id === app) !== undefined;
        },

    },
}
</script>

<style scoped>

.scheduledCampaign {
    background: #fb8c0020;
}

</style>
